module.exports = {"title":"W2s","category":"Payroll and Benefits","__content":"<p>W-2s will be available in the Spur app at the end of the year.</p>\n"}